/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index global-error to autogenerate all the components and extensions
 * Used by "prepareGlobalErrors"
 */

import GlobalError from './global-error/GlobalError'
export * from './global-error/GlobalError'
export default GlobalError
